__turbopack_context__.v({
  "container": "AccountMenu-module-scss-module__pJIbEW__container",
});
